<template>
  <div
    class="poster"
    :class="{ hide, sharePost: showType == 1, showPost: showType == 2 }"
    ref="poster"
  >
    <canvas ref="canvas"></canvas>
    <img class="posterImage" v-if="posterURL" :src="posterURL" />
  </div>
</template>

<script>
export default {
  props: [
    'hide',
    'qrCodeURL',
    'posterImg',
    'showType',
    'qrCodeWidth',
    'qrCodeTop',
    'qrCodeLeft'
  ],
  data() {
    return {
      posterURL: ''
    };
  },
  computed: {},
  mounted() {
    setTimeout(this.drawPoster);
  },
  watch: {
    qrCodeURL: {
      handler() {
        this.drawPoster();
      },
      immediate: true
    },
    posterImg: {
      handler() {
        this.drawPoster();
      },
      immediate: true
    }
  },
  methods: {
    async drawPoster(quality = 1) {
      // 设计稿海报尺寸宽度750
      // 二维码宽度192,top:835,left:526
      let canvas = this.$refs.canvas;
      let poster = this.$refs.poster;
      let qrLeft = Number(this.qrCodeLeft) || 526;
      let qrTop = Number(this.qrCodeTop) || 835;
      // console.log(this.qrCodeTop, 'qrCodeTop+++');
      let widthPercent = this.qrCodeWidth || (qrLeft == 526 ? 192 : 310); //长款比例
      let heightPercent = this.qrCodeWidth || (qrTop == 835 ? 192 : 310); //长款比例
      // console.log(
      //   !this.posterImg,
      //   !canvas,
      //   !poster,
      //   !this.qrCodeURL,
      //   'drawasdhasjdhajsdhjasdhjash--->',
      //   this.posterImg,
      //   this.qrCodeURL
      // );
      if (!this.posterImg || !canvas || !poster || !this.qrCodeURL) return;
      // console.log('99999000');
      canvas.height = poster.clientHeight * quality * 2;
      canvas.width = poster.clientWidth * quality * 2;
      let ctx = canvas.getContext('2d');
      let qrcode = await this.createImage(this.qrCodeURL);
      let bg = await this.createImage(this.posterImg + `?date=${Date.now()}`);
      // console.log(qrcode, bg, 'createImage');
      ctx.drawImage(bg, 0, 0, canvas.width, canvas.height);
      ctx.drawImage(
        qrcode,
        (qrLeft / 750) * canvas.width,
        (qrTop / 750) * canvas.width,
        (widthPercent / 750) * canvas.width,
        (heightPercent / 750) * canvas.width
      );
      // console.log(canvas.toDataURL(), 'canvas.toDataURL()');
      this.posterURL = canvas.toDataURL();
    },
    toBlobUrl() {
      return new Promise(resolve => {
        let canvas = this.$refs.canvas;
        canvas.toBlob(
          function(blob) {
            var url = URL.createObjectURL(blob);
            resolve(url);
          },
          'image/jpeg',
          0.2
        );
      });
    },
    base64ToBlob(urlData, type) {
      let arr = urlData.split(',');
      let mime = arr[0].match(/:(.*?);/)[1] || type;
      // 去掉url的头，并转化为byte
      let bytes = window.atob(arr[1]);
      // 处理异常,将ascii码小于0的转换为大于0
      let ab = new ArrayBuffer(bytes.length);
      // 生成视图（直接针对内存）：8位无符号整数，长度1个字节
      let ia = new Uint8Array(ab);
      for (let i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i);
      }
      return new Blob([ab], {
        type: mime
      });
    },
    createImage(url) {
      var url2 = '';
      // console.log(url, 'createImage---->function');
      if (url.indexOf('base64') > -1) {
        let file = url; // 把整个base64给file
        var type = 'image/png'; // 定义图片类型（canvas转的图片一般都是png，也可以指定其他类型）
        let conversions = this.base64ToBlob(file, type); // 调用base64转图片方法----vue写法
        window.URL = window.URL || window.webkitURL; //blob对象转换为blob-url
        url2 = window.URL.createObjectURL(conversions);
      }
      // console.log(url2, '00090129301920');
      let img = new Image();
      img.crossOrigin = 'anonymous'; //加跨域
      img.src = url.indexOf('base64') > -1 ? url2 : url;

      return new Promise((resolve, reject) => {
        img.onload = () => resolve(img);
        img.onerror = err => {
          console.log('image---load--error');
          reject(err);
        };
      });
    },
    async getBase64(quality = 1) {
      if (quality !== 1 && this.posterURL) {
        return this.posterURL;
      }
      try {
        await this.drawPoster(quality);
      } catch (error) {
        console.log(error, '产生海报error');
      }
      return this.posterURL;
    }
  }
};
</script>

<style lang="less" scoped>
.poster {
  z-index: 3;
  &.sharePost {
    position: fixed;
    top: 0;
    transform: translateY(-100%);
    width: 750px;
    height: 1080px;
    &.hide {
      top: -10000px;
    }
  }
  .posterImage {
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    // -webkit-touch-callout: none;
    // -webkit-user-select: none;
    // -khtml-user-select: none;
    // -moz-user-select: none;
    // -ms-user-select: none;
    // user-select: none;
    img {
      width: 100%;
      height: 100%;
    }
  }
  &.showPost {
    width: 750px;
    height: 1080px;
    box-shadow: 0px 12px 30px 0px rgba(46, 49, 56, 0.1);
    border-radius: 20px;
    overflow: hidden;
    position: absolute;
    canvas {
      display: none;
      z-index: 0;
    }
    .posterImg {
      position: absolute;
      top: 0px;
      left: 0px;
      z-index: 3;
    }
    .qrCode {
      position: absolute;
      right: 28px;
      bottom: 60px;
      width: 108px;
    }
  }
}
</style>
